import React from 'react';
export function Hero() {
  return <section className="relative w-full bg-navy-50" data-id="element-210" data-mp="3q74h710ubfvn">
      <div className="absolute inset-0 overflow-hidden" data-id="element-211" data-mp="ejd0dpaw3gqn">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
        backgroundBlendMode: 'overlay'
      }} data-id="element-212" data-mp="ehtixvdhyzna" />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-navy-600/20" data-id="element-213" data-mp="xaxj7zl80aqv" />
      </div>
      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10" data-id="element-214" data-mp="s9ghk1uwwk98">
        <div className="max-w-3xl" data-id="element-215" data-mp="nbewxchu8cvn">
          <h1 className="text-3xl md:text-5xl font-bold text-navy-800 mb-4" data-id="element-216" data-mp="neknkw647mth">
            Advancing Truth in Microbiome Science
          </h1>
          <p className="text-lg md:text-xl text-navy-700 mb-8" data-id="element-217" data-mp="3825yir8x69lw">
            The California Institute for Microbiome Research (CalMiR) is
            redefining health science with pharmaceutical-grade rigor,
            independent certification, and global outreach — bridging the gap
            between wellness, therapeutics, and consumer trust.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-218" data-mp="39cpfz2rm3z6l">
            <a href="/research" className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm" data-id="element-219" data-mp="3e8ecex8c4zyo">
              Learn About Our Research
            </a>
            <a href="/certification" className="px-6 py-3 bg-white text-teal-600 border border-teal-600 rounded-md hover:bg-gray-50 transition-colors duration-200" data-id="element-220" data-mp="35akn468zn6l0">
              See Ukweli Certified™
            </a>
            <a href="/support-us" className="px-6 py-3 bg-navy-800 text-white rounded-md hover:bg-navy-900 transition-colors duration-200 shadow-sm" data-id="element-221" data-mp="2hkgipwnz72sy">
              Support the Mission
            </a>
          </div>
        </div>
      </div>
    </section>;
}